import { Link } from './types';

const linkTheme: Link = {
	colors: {
		color: '',
		modes: {
			light: { color: 'blue.700' },
			dark: { color: 'blue.400' }
		}
	}
};

export default linkTheme;
